var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ResponseError } from 'grilnica-share';
import axios from 'axios';
import downloadjs from 'downloadjs';
var ERROR_MESSAGE_DEFAULT = 'Произошла неизвестная ошибка. Обратитесь в службу поддержки.';
function getToken() {
    return JSON.parse(localStorage.getItem('token'));
}
function getAuthorizationHeader() {
    var token = getToken();
    return token ? { Authorization: 'Bearer ' + token.accessToken } : {};
}
function getHeaders() {
    return Object.assign({ 'Content-Type': 'application/json' }, getAuthorizationHeader());
}
function handleRequest(url, options, onError, onSending) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var headers, config, response, error, e_1, err;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    if (onSending) {
                        onSending(true);
                    }
                    headers = Object.assign(getHeaders(), options.headers || {});
                    config = __assign(__assign({ url: url }, options), { headers: __assign(__assign({}, headers), { 'Cache-Control': 'no-cache' }), validateStatus: function (status) {
                            return true;
                        } });
                    return [4 /*yield*/, axios.request(config)];
                case 1:
                    response = _b.sent();
                    if (response.status >= 200 && response.status < 300) {
                        if (onSending) {
                            onSending(false);
                        }
                        return [2 /*return*/, response.data];
                    }
                    else {
                        error = new ResponseError(response.status, response.data.errorMessage, (_a = response.data) === null || _a === void 0 ? void 0 : _a.objectsMap);
                        if (!error.errorMessage) {
                            error.errorMessage = ERROR_MESSAGE_DEFAULT;
                        }
                        if (onSending) {
                            onSending(false);
                        }
                        if (onError) {
                            onError(error);
                        }
                        else {
                            throw error;
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _b.sent();
                    err = void 0;
                    if (e_1.status && e_1.errorMessage) {
                        err = e_1;
                    }
                    else {
                        err = new ResponseError(500, ERROR_MESSAGE_DEFAULT);
                    }
                    if (onSending) {
                        onSending(false);
                    }
                    if (onError) {
                        onError(err);
                    }
                    else {
                        throw err;
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function apiGet(url, options, onError, onSending, timeout) {
    return __awaiter(this, void 0, void 0, function () {
        var urlObject, param;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    urlObject = new URL(url);
                    if (options) {
                        for (param in options) {
                            urlObject.searchParams.append(param, options[param]);
                        }
                    }
                    return [4 /*yield*/, handleRequest(urlObject.toString(), {
                            method: 'GET',
                            timeout: timeout ? timeout : undefined,
                        }, onError, onSending)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function apiPost(url, data, options, onError, onSending, timeout) {
    return __awaiter(this, void 0, void 0, function () {
        var urlObject, param, config;
        return __generator(this, function (_a) {
            urlObject = new URL(url);
            if (options) {
                for (param in options) {
                    urlObject.searchParams.append(param, options[param]);
                }
            }
            config = {
                method: 'POST',
                data: JSON.stringify(data),
                timeout: timeout ? timeout : undefined,
            };
            return [2 /*return*/, handleRequest(urlObject.toString(), config, onError, onSending)];
        });
    });
}
function apiDownloadFile(url, fileName, options, onError, onSending) {
    return __awaiter(this, void 0, void 0, function () {
        var config, content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = __assign({ method: 'GET', responseType: 'blob' }, options);
                    return [4 /*yield*/, handleRequest(url, config, onError, onSending)];
                case 1:
                    content = _a.sent();
                    downloadjs(content, fileName);
                    return [2 /*return*/];
            }
        });
    });
}
function apiPostFile(url, formData, options, onError, onSending) {
    return __awaiter(this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            config = __assign({ method: 'POST', data: formData }, options);
            return [2 /*return*/, handleRequest(url, config, onError, onSending)];
        });
    });
}
function apiDownloadFileWithProgressBar(url, fileName, onDownloadProgress, options, onError, onSending) {
    return __awaiter(this, void 0, void 0, function () {
        var config, content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = __assign({ method: 'GET', responseType: 'blob', onDownloadProgress: function (percentDone) {
                            var progressPercent = Math.floor((percentDone.loaded * 100) / percentDone.total);
                            if (onDownloadProgress)
                                onDownloadProgress(progressPercent);
                        } }, options);
                    return [4 /*yield*/, handleRequest(url, config, onError, onSending)];
                case 1:
                    content = _a.sent();
                    downloadjs(content, fileName);
                    return [2 /*return*/];
            }
        });
    });
}
function apiPostFileWithProgressBar(url, formData, onUploadProgress, options, onError, onSending) {
    return __awaiter(this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            config = {
                method: 'POST',
                data: formData,
                responseType: 'json',
                onUploadProgress: function (percentDone) {
                    var progressPercent = Math.floor((percentDone.loaded * 100) / percentDone.total);
                    if (onUploadProgress)
                        onUploadProgress(progressPercent);
                },
            };
            return [2 /*return*/, handleRequest(url, config, onError, onSending)];
        });
    });
}
export { apiGet, apiPost, apiDownloadFile, apiPostFile, apiDownloadFileWithProgressBar, apiPostFileWithProgressBar, };
//# sourceMappingURL=index.js.map